export default __webpack_public_path__ + "static/vector-shape3-b3a4d0603a1a0e4c160daab01fccc061.png";